import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../common/state/hooks";
import { setAlert } from "../../alert/state/alertsSlice";
import type { SampleCourseSurface } from "../state/onboardingSlice";
import {
  cloneSampleCourse,
  selectOnboardingAudience,
  selectOnboardingRemote,
} from "../state/onboardingSlice";

export const useSampleCourseClone = (surface: SampleCourseSurface) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const audience = useAppSelector(selectOnboardingAudience);
  const remote = useAppSelector(selectOnboardingRemote);
  const [busy, setBusy] = useState(false);

  const canExplore = audience !== "enduser" && remote !== null && remote.sampleCourse === null;

  const explore = async (): Promise<void> => {
    if (busy) {
      return;
    }
    setBusy(true);
    const result = await dispatch(cloneSampleCourse({ surface }));
    if (cloneSampleCourse.fulfilled.match(result)) {
      dispatch(setAlert({ type: "success", msg: t("onboarding.sampleCourse.success") }));
      navigate("/courses");
    } else {
      dispatch(setAlert({ type: "danger", msg: t("onboarding.sampleCourse.failure") }));
    }
    setBusy(false);
  };

  return { canExplore, busy, explore };
};
